<template lang="pug">
.reviews-wrap
  .vv-reviews-slick
    div(v-for="(review, index) in topTenReviews")
      .review-item
        .review-box-outer
          .review-box-inner
            .review-content
              .review
                .review-title {{$tc('ui.customer_review')}}
                .rate
                  span.star(:class="{'active' : review.average_rating > 0}")
                    i.fas.fa-star
                  span.star(:class="{'active' : review.average_rating > 1}")
                    i.fas.fa-star
                  span.star(:class="{'active' : review.average_rating > 2}")
                    i.fas.fa-star
                  span.star(:class="{'active' : review.average_rating > 3}")
                    i.fas.fa-star
                  span.star(:class="{'active' : review.average_rating > 4}")
                    i.fas.fa-star
                div(v-html="review.comment")
                  br
                  | Win Amount: RM30.00
                .reply
                template(v-if="review.reply")
                  //- .review-title {{$tc('ui.developer_response')}}
                  .review-title Epicwin: 
                  | {{review.reply}}
        .review-user
          img.user-icon(src='/new/img/winner.svg')
          .user-info-wrap
            .user-name {{review.nickname}}
            .review-date {{$moment(review.created_date).fromNow()}}
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
export default {
  data(){
    return{
      topTenReviews: []
    }
  },
  computed: {
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  mounted(){
    this.getReview();
    
  },
  updated(){
    if(this.topTenReviews){
      $(".vv-reviews-slick").not('.slick-initialized').slick({
        dots: true,
          infinite: true,
          arrows: false,
          speed: 400,
          autoplaySpeed: 1800,
          slidesToShow: 5,
          slidesToScroll: 1,
          pauseOnFocus: false,
          autoplay: true,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 1
              }
            }
          ]      
      });
    }
  },
  methods:{
    getReview(){
      let comp = "epicwin"
      this.$store
        .dispatch("user/getSurveyList", {comp})
        .then(response => {
          if (response.success == true) {
            this.topTenReviews = response.data;
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
        });
    },
  }
}
</script>